import Icon from 'rv-components/react/Icon'
import Slider from 'components/Slider'
import useMediaQuery from 'hooks/useMediaQuery'
import Text from 'components/Text'

const Carousel = ({ items }) => {
  const isDesktop = useMediaQuery('desktop')

  const settingsSlick = {
    dots: true,
    infinite: true,
    arrows: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  const carouselCallback = () => {
    const slickNext = document.querySelector('.banner-hero .slick-next')
    const slickPrev = document.querySelector('.banner-hero .slick-prev')

    slickNext.innerHTML = 'Próximo'
    slickNext.ariaLabel = 'Próximo'
    slickPrev.innerHTML = 'Anterior'
    slickPrev.ariaLabel = 'Anterior'

    const dotsButton = document.querySelectorAll(
      '.banner-hero ul.slick-dots li button'
    )
    const dots = document.querySelectorAll('.banner-hero ul.slick-dots li')

    if (dots && dotsButton) {
      dotsButton.forEach((button) => button.setAttribute('aria-hidden', 'true'))
      dots.forEach((dot, index) =>
        dot.setAttribute(
          'aria-label',
          `Slide ${index + 1}: ${items[index].main_text}`
        )
      )
    }
  }

  const renderItems = () => {
    return items.map((item, index) => (
      <div className="landing-advantage-item" key={index}>
        <div className="item-icon">
          <Icon iconId={item.icon_name} />
        </div>
        <Text h3 className="item-main-text">
          {item.main_text}
        </Text>
        <Text p className="item-sub-text">
          {item.sub_text}
        </Text>
      </div>
    ))
  }

  return isDesktop ? (
    renderItems()
  ) : (
    <Slider
      settings={settingsSlick}
      className={'banner-hero'}
      callback={carouselCallback}
    >
      {renderItems()}
    </Slider>
  )
}

export default Carousel
